// Build canonical listing URLs preferring slug over UUID.
type WithSlugOrId = { slug?: string | null; id?: string | null } | null | undefined;

export const slugOrId = (record: WithSlugOrId): string =>
  (record?.slug || record?.id || '') as string;

export const propertyUrl = (record: WithSlugOrId) => `/property/${slugOrId(record)}`;
export const projectUrl = (record: WithSlugOrId) => `/projects/${slugOrId(record)}`;
